import Vue from 'vue';
import VueRouter from 'vue-router';

import ProductBasePage from '../pages/product/ProductBasePage';
import ProductDetailPage from '../pages/product/ProductDetailPage';
import ProductIndexPage from '../pages/product/ProductIndexPage';

import TypeBasePage from '../pages/type/TypeBasePage';
import TypeDetailPage from '../pages/type/TypeDetailPage';
import TypeIndexPage from '../pages/type/TypeIndexPage';

import InvestmentManagerBasePage from '../pages/investment_manager/InvestmentManagerBasePage';
import InvestmentManagerDetailPage from '../pages/investment_manager/InvestmentManagerDetailPage';
import InvestmentManagerIndexPage from '../pages/investment_manager/InvestmentManagerIndexPage';

import SyariahIndexPage from '../pages/syariah/SyariahIndexPage';

import CustodianBankIndexPage from '../pages/custodian_bank/CustodianBankIndexPage';

import Guards from './guards';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect() {
      return '/jenis-reksa-dana';
    },
  },
  {
    path: '/produk',
    component: ProductBasePage,
    children: [
      {
        path: '',
        name: 'mutualFundProduct',
        component: ProductIndexPage,
      },
      {
        path: ':detail',
        name: 'mutualFundProductDetail',
        component: ProductDetailPage,
        props: true,
        beforeEnter: Guards.isRouteExist,
      },
    ],
  },
  {
    path: '/jenis-reksa-dana',
    component: TypeBasePage,
    children: [
      {
        path: '',
        name: 'mutualFundType',
        component: TypeIndexPage,
      },
      {
        path: ':detail',
        name: 'mutualFundTypeDetail',
        component: TypeDetailPage,
        props: true,
        beforeEnter: Guards.isRouteExist,
      },
    ],
  },
  {
    path: '/manajer-investasi',
    component: InvestmentManagerBasePage,
    children: [
      {
        path: '',
        name: 'mutualFundInvestmentManager',
        component: InvestmentManagerIndexPage,
      },
      {
        path: ':detail',
        name: 'mutualFundInvestmentManagerDetail',
        component: InvestmentManagerDetailPage,
        props: true,
        beforeEnter: Guards.isRouteExist,
      },
    ],
  },
  {
    path: '/bank-kustodian',
    component: CustodianBankIndexPage,
  },
  {
    path: '/reksa-dana-syariah',
    component: SyariahIndexPage,
  },
  {
    path: '*',
    name: '404',
    beforeEnter: Guards.redirectToNotFound,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: '/bukareksa',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
});

export default router;
